import { getGridNumericOperators, GridColDef } from "@mui/x-data-grid";
import { formatCurrency, formatHandlerCode, formatIsoDate, formatIsoDateWithTime, formatPercentage } from "../../utils/namesFormater"; // עדכני לפי מיקום הקובץ שלך
import { colorAdjustedProductType, colorHandlerCode, colorProductType, colorRuleType, colorProductTypeUniversal, colorHandlerCodeUniversal } from "../../utils/colorEnumFormatter";
import { formatAdjustedProductType, formatProductType, formatProductTypeExtended, formatRuleType, formatManagementFeePathFeatures } from "../../utils/enumFormatter";
import { formatProductTypeUniversal } from "../../utils/productTypeUniversalFormatter";
import { formatHandlerCodeUniversal } from "../../utils/handlerCodeUniversalFormatter";
import { UserTaskMimshakData } from "../../interfaces/DTO/userTask/UserTask";
import { AdjustedProductType, FundAction, FundTransferDetails, InvestmentPathDetail, Mimshak, Product, ProductType } from "../../interfaces/DTO/mislaka_xml_models";
import { HandlerAutocompleteField } from "../Autocompletes/HandlerAutocompleteField";
import { GroupedProducerAutocompleteField } from "../Autocompletes/ProducerAutocompleteField";
import { AppGridColDef } from "../EditableDataGridStyle";
import { ProductTypeAutocompleteField } from "../Autocompletes/ProductTypeAutocompleteField";
import { Autocomplete, Box, Chip, List, ListItem, ListItemText, TextField, Tooltip, Typography } from "@mui/material";
import { GuaranteedConversionFactorsChip } from "../../components/PersonFinancialData/Chips/GuaranteedConversionFactorsChip";
import { LoanChip } from "../../components/PersonFinancialData/Chips/LoanChip";
import { PolicyStatusChip } from "../../components/PersonFinancialData/Chips/PolicyStatusChip";
import { formatPeriodLabel } from "./chartUtils";
import React from "react";
import { EmailEditColumn } from "./EmailEditColumn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { AgentTaskType } from "../../interfaces/DTO/agent/agentPhoneBook";
import { colorAgentTaskType, formatAgentTaskType } from "../../utils/featuresFormatter";
import { EnumSelectEditCell } from "./columns/EnumSelectEditCell";
import { MimshakService } from "../../services/mimshakService";
import { DataAccessTypeEnum } from "../../interfaces/DTO/features/ShareContact";
import { PolicyStatuses } from "../../components/PersonFinancialData/Chips/PolicyStatuses";
import { RuleType } from "../../interfaces/DTO/insights/PolicyInsightsRuleBased";
import { getColorForPercentileNumber } from "../../utils/fundsFormatter";
import { ManagementFeeDetails, PensionFeeExpenseType } from "../../interfaces/DTO/mislaka_xml_pension_models";
import { ManagementFeeDisplay } from "../../components/PersonFinancialData/Chips/ManagementFeeDisplay";

export const nullableBooleanColumn = (
  field: string,
  headerName: string,
  width: number = 120,
  editable: boolean = false,
  trueColor?: string
): GridColDef => ({
  field,
  headerName,
  width,
  editable,
  type: "boolean",
  renderCell: (params) => {
    if (!params.value) return null;
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: trueColor || "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "0.75rem",
            fontWeight: 700,
          }}
        >
          ✓
        </Box>
      </Box>
    );
  },
});

export const percentageColumn = (
  field: string,
  headerName: string,
  width: number =100,
  bold: boolean = false
): GridColDef => ({
  field,
  headerName,
  width,
  renderCell: (params: any) =>
    typeof params.value === "number" ? (
      <span dir="ltr" style={{ fontWeight: bold ? "bold" : "normal" }}>
        {formatPercentage(params.value)}
      </span>
    ) : (
      params.value ?? ""
    ),
    filterOperators: getGridNumericOperators(),
});

export const currencyColumn = (
    field: string,
    headerName: string,
    width: number,
    bold: boolean = true
  ): GridColDef => ({
    field,
    headerName,
    width,
    renderCell: (params: any) =>
      typeof params.value === "number" && params.value !== 0 ? (
        <span dir="ltr" style={{ fontWeight: bold ? "bold" : "normal" }}>
          {formatCurrency(params.value)}
        </span>
      ) : params.value === 0 ? (
        null
      ) : (
        params.value
      ),
      filterOperators: getGridNumericOperators(),
  });
  export const numericColumn = (
    field: string,
    headerName: string,
    width: number = 100,
    valueGetter?: (params: any,row:any) => any
  ): GridColDef => ({
    field,
    headerName,
    width,
    type: "number",
    valueGetter,
     renderCell: (params: any) =>
      typeof params.value === "number" ? (
        <span dir="ltr" >
          {params.value}
        </span>
      ) : (
        params.value
      ),
    filterOperators: getGridNumericOperators(),
  });
  export const numericEnumColumn = <T extends number>(
    field: string,
    headerName: string,
    enumValues: readonly T[] | T[],
    formatFn: (value: T) => string,
    width: number = 160
  ): GridColDef => ({
    field,
    headerName,
    width,
    type: "singleSelect",
    valueOptions: enumValues.map((v) => ({
      value: v,
      label: formatFn(v),
    })),
    valueFormatter: (params) =>
      params != null ? formatFn(params as T) : "—",
  });
  export const enumColumn = <T extends string>(
    field: string,
    headerName: string,
    enumValues: readonly T[] | T[],
    formatFn: (value: T) => string,
    width: number = 160
  ): GridColDef => ({
    field,
    headerName,
    width,
    type: "singleSelect",
    valueOptions: enumValues.map((v) => ({
      value: v,
      label: formatFn(v),
    })),
    valueFormatter: (params) =>
      params ? formatFn(params as T) : "—",
  });
export const editableEnumColumn = <T extends string>(
      field: string,
      headerName: string,
      enumValues: readonly T[],
      formatFn: (value: T) => string,
      width: number = 160
    ): GridColDef => ({
      field,
      headerName,
      width,
      editable: true,
      type: "singleSelect",
      valueOptions: enumValues.map((v) => ({
        value: v,
        label: formatFn(v),
      })),
      valueFormatter: (params) =>
        params !== undefined ? formatFn(params as T) : "—",
      renderEditCell: (params) => (
        <EnumSelectEditCell {...params} enumObject={enumValues} formatFn={formatFn} />
      ),
    });
export function editableEnumChipsColumn<T extends string | number>(
  field: string,
  headerName: string,
  enumValues: T[],
  getLabel: (value: T) => string,
  getColor?: (value: T) => string,
  width: number = 300
): AppGridColDef {
  return {
    field,
    headerName,
    width,
    editable: true,
    type: "singleSelect", // נדרש בשביל סינון
    valueOptions: enumValues,
    sortComparator: (v1: T[], v2: T[]) => {
  const first1 = v1?.[0] ?? "";
  const first2 = v2?.[0] ?? "";
  return String(first1).localeCompare(String(first2));
},
    renderCell: (params) => (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {(params.value || []).map((val: T) => (
          <Chip
            key={val}
            label={getLabel(val)}
            size="small"
            sx={{
              bgcolor: getColor?.(val) || "primary.main",
              color: "#fff",
            }}
          />
        ))}
      </Box>
    ),
    renderEditCell: (params: any) => {
      const value: T[] = params.value || [];

      const handleChange = (_event: any, newValue: T[]) => {
        params.api.setEditCellValue({
          id: params.id,
          field: params.field,
          value: newValue,
        });
      };

      return (
        <Autocomplete
          multiple
          fullWidth
          options={enumValues}
          value={value}
          onChange={handleChange}
          getOptionLabel={getLabel}
          renderTags={(selected, getTagProps) =>
            selected.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={option}
                label={getLabel(option)}
                sx={{ bgcolor: getColor?.(option) || "primary.main", color: "#fff" }}
              />
            ))
          }
          renderInput={(params) => (
            <TextField {...params} variant="standard" placeholder={`בחר ${headerName}`} />
          )}
        />
      );
    },
  };
}
export const percentileColorColumn = (
  field: string,
  headerName: string,
  width: number = 70
): GridColDef => ({
  field,
  headerName,
  width,
  sortable: false,
  renderCell: (params: any) => {
    const value = Number(params.value);
    const color = isNaN(value) ? "#ccc" : getColorForPercentileNumber(value);

    const tooltip = isNaN(value)
      ? "אין נתון להשוואת תשואה"
      : `דירוג: ${value}%\nתשואה מצטברת ל-6 חודשים אחרונים\nיחסית לקרנות עם חשיפה דומה למניות`;

    return (
      <Box
        sx={{
          width: 16,
          height: 16,
          borderRadius: "4px",
          backgroundColor: color,
        }}
        title={tooltip}
      />
    );
  },
});
export function singleChipEnumColumn<T extends string | number>(
  field: string,
  headerName: string,
  enumValues: T[],
  getLabel: (value: T) => string,
  getColor?: (value: T) => string,
  width: number = 300
): AppGridColDef {
  return {
    field,
    headerName,
    width,
    editable: true,
    type: "singleSelect", // נדרש בשביל סינון
     valueOptions: enumValues.map((val) => ({
      value: val,
      label: getLabel(val),
    })),
    sortComparator: (v1: T, v2: T) => {
      return String(v1 ?? "").localeCompare(String(v2 ?? ""));
    },
    renderCell: (params) => {
      const val = params.value as T | undefined;
      if (!val) return null;
      return (
        <Chip
          label={getLabel(val)}
          size="small"
          sx={{
            bgcolor: getColor?.(val) || "primary.main",
            color: "#fff",
          }}
        />
      );
    },
  };
}
  export const editableEnumChipColumn = <T extends string>(
    field: string,
    headerName: string,
    enumValues: readonly T[],
    formatFn: (value: T) => string,
    colorFn: (value: T) => string,
    width: number = 160
  ): GridColDef => ({
    field,
    headerName,
    width,
    editable: true,
    type: "singleSelect",
    valueOptions: enumValues.map((v) => ({
      value: v,
      label: formatFn(v),
    })),
     valueFormatter: (params) =>
        params !== undefined ? formatFn(params as T) : "—",
    renderCell: (params) => {
      const value = params.row?.[field] as T;
       const bgColor = colorFn(value);
      return (
        <Chip
          label={formatFn(value)}
          sx={{
            backgroundColor: bgColor,
            color: "#fff",
            fontWeight: 500,
          }}
          size="small"
        />
      );
    },
    renderEditCell: (params) => (
      <EnumSelectEditCell
        {...params}
        enumObject={enumValues}
        formatFn={formatFn}
      />
    ),
  });
  export const editableColoredCellColumn = <T extends string>(
  field: string,
  headerName: string,
  enumValues: readonly T[],
  formatFn: (value: T) => string,
  colorFn: (value: T) => string, // מחזיר HEX
  width: number = 160
): GridColDef => ({
  field,
  headerName,
  width,
  editable: true,
  type: "singleSelect",
  valueOptions: enumValues.map((v) => ({
    value: v,
    label: formatFn(v),
  })),
    valueFormatter: (params) =>
        params !== undefined ? formatFn(params as T) : "—",
  renderCell: (params) => {
    const value = params.row?.[field] as T;
    const bgColor = colorFn(value);
    const label = formatFn(value);

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: bgColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 500,
          borderRadius: 4,
        }}
      >
        {label}
      </div>
    );
  },
  renderEditCell: (params) => (
    <EnumSelectEditCell
      {...params}
      enumObject={enumValues}
      formatFn={formatFn}
    />
  ),
});
  export const isoDateColumn = (
    field: string,
    headerName: string,
    width: number = 130
  ): GridColDef => ({
    field,
    headerName,
    width,
    type: "date",
    // ערך שאינו תאריך תקין (ריק, "-" וכו') – null, כדי שלא יוצג NaN-NaN-NaN
    valueGetter: (params) => {
      if (!params) return null;
      const date = new Date(params);
      return isNaN(date.getTime()) ? null : date;
    },
    valueFormatter: (params) => formatIsoDate(params),
  });

  export const isoDateTimeColumn = (
    field: string,
    headerName: string,
    width: number = 180
  ): GridColDef => ({
    field,
    headerName,
    width,
    type: "dateTime",
    valueGetter: (params:any) => {
      if (!params) return null;
      // אם זה כבר Date object, נחזיר אותו
      if (params instanceof Date) return params;
      // אחרת ננסה להמיר
      return new Date(params);
    },
    renderCell: (params) => {
      const row = params.row || {};
      const value = row[field];
      if (!value) return null;
      // נוודא שאנחנו מעבירים string ל-formatIsoDateWithTime
      const isoString = value instanceof Date ? value.toISOString() : value;
      return formatIsoDateWithTime(isoString);
    },
  });

  export const productTypeColumn = (): GridColDef => ({
    field: "product_type",
    headerName: "סוג מוצר",
    width: 150,
    valueGetter: (params: any) => formatProductType(params), // ✅ מגדיר את הערך לחיפוש/סינון
    renderCell: (params: any) => (
      <span
        style={{
          color: colorProductType(params.row.product_type), // לוקח את הקוד המקורי
          fontWeight: "bold",
        }}
      >
        {params.value}
      </span>
    ),
  });
export const adjustedProductTypeColumn = (): GridColDef => {
  const enumValues = Object.values(AdjustedProductType).filter((v) => typeof v === "number") as AdjustedProductType[];

  return {
    field: "adjusted_product_type",
    headerName: "סוג מוצר",
    width: 150,
    type: "singleSelect",
    valueOptions: enumValues.map((v) => ({
      value: v,
      label: formatAdjustedProductType(v),
    })),
    renderCell: (params: any) => {
      const row = params?.row ?? {};
      const adjusted = row.adjusted_product_type ?? row.product_type;
      return (
        <span
          style={{
            color: colorAdjustedProductType(adjusted),
            fontWeight: "bold",
          }}
        >
          {formatAdjustedProductType(adjusted)}
        </span>
      );
    },
  };
};

export const adjustedProductTypeColumnFullColor = (): GridColDef => {
  const enumValues = Object.values(AdjustedProductType).filter((v) => typeof v === "number") as AdjustedProductType[];

  return {
    field: "adjusted_product_type",
    headerName: "סוג מוצר",
    width: 160,
    type: "singleSelect",
    valueOptions: enumValues.map((v) => ({
      value: v,
      label: formatAdjustedProductType(v),
    })),
    renderCell: (params: any) => {
      const row = params?.row ?? {};
      const adjusted = row.adjusted_product_type ?? row.product_type;
      // not a Mislaka type (a manual asset, e.g. an investment portfolio) - by its product type
      const raw = typeof row.raw_product_type === "number" ? row.raw_product_type : row.product_type;
      const label = formatAdjustedProductType(adjusted) || formatProductTypeUniversal(raw);
      return (
        <Box
          sx={{
            backgroundColor: formatAdjustedProductType(adjusted) ? colorAdjustedProductType(adjusted) : colorProductTypeUniversal(raw),
            color: "white",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            width: "100%",
            textAlign: "center",
          }}
        >
          {label}
        </Box>
      );
    },
  };
};

export const productTypeExtendedColumn = (productFieldName: string = "product"): GridColDef => ({
  field: "product_type",
  headerName: "סוג מוצר ",
  width: 180,
  valueGetter: (params: ProductType,row) => {
    const product:Product = row?.[productFieldName];
    const policy = product?.policies_or_accounts?.[0];
    const type = product?.details?.product_type;

    if (!product || !policy || typeof type !== "number") return "-";

    return formatProductTypeExtended(type, policy);
  }, // נניח ששני הערכים האלה קיימים בשורה
  renderCell: (params: any) => {
    const type = params.row?.product_type;
   

    return (
      <span
        style={{
          color: colorProductType(type),
          fontWeight: "bold",
        }}
      >
        {params.value}
      </span>
    );
  },
});


 export const handlerCodeColumn = (
  field: string = "handler_code",
  headerName: string = "יצרן",
  backgroundColor?: string
): GridColDef => ({
  field,
  headerName,
  width: 150,
    valueGetter: (params: any) => formatHandlerCode(params), // ✅ לטובת חיפוש וסינון
renderCell: (params: any) => {
  const row = params.row || {};
  const code = row[field];

  if (!code) return null;

  const color = colorHandlerCode(code);
  const label = formatHandlerCode(code);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        backgroundColor: backgroundColor || "transparent",
        width: "100%",
        height: "100%",
        paddingRight: 4,
      }}
    >
      {color && (
        <div
          style={{
            width: 10,
            height: 30,
            borderRadius: "20%",
            backgroundColor: color,
            flexShrink: 0,
          }}
        />
      )}
      <span>{label}</span>
    </div>
  );
}

});

  export const editableProductTypeColumn = (required: boolean = false): AppGridColDef => ({
    field: "product_type",
    headerName: "סוג מוצר",
    width: 150,
    editable: true,
    required: required,
    valueGetter: (params: any) => formatProductType(params), // תצוגה לסינון/חיפוש
    renderCell: (params: any) => (
      <span
        style={{
          color: colorProductType(params.row.product_type), // צבע לפי סוג מוצר
          fontWeight: "bold",
        }}
      >
        {params.value}
      </span>
    ),
    renderEditCell: (params: any) => (
      <ProductTypeAutocompleteField
        value={params.value ?? -1} // אם אין ערך -1 (למשל)
        showIcons={false}
        onChange={(newValue) =>
          params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: newValue,
          })
        }
      />
    ),
  });
 export const editableEmailColumn = (
  required?: boolean,
  fieldName: string = "email"
): AppGridColDef => ({
  field: fieldName,
  headerName: "אימייל",
  width: 250,
  editable: true,
  required,
  renderEditCell: (params: any) => (
    <EmailEditColumn params={params} required={required} fieldName={fieldName} />
  ),
});
  // includeInvestmentHouses: the investment houses can be picked too (one list, grouped: Mislaka producers / investment houses)
  export const editableHandlerCodeColumn = (required: boolean = false, includeInvestmentHouses: boolean = false): AppGridColDef => {
    const format = includeInvestmentHouses ? formatHandlerCodeUniversal : formatHandlerCode;
    const setValue = (params: any) => (newValue: string) =>
      params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue });
    return {
      field: "handler_code",
      headerName: "יצרן",
      width: includeInvestmentHouses ? 260 : 200,
      editable: true, // ✅ מאוד חשוב
      required:required,
      valueGetter: (params: any) => format(params), // לתצוגה בסינון/חיפוש
      renderCell: (params: any) => (
        <span>{format(params.value)}</span> // מציג את השם של היצרן
      ),
      renderEditCell: (params: any) =>
        includeInvestmentHouses ? (
          <GroupedProducerAutocompleteField value={params.value || ""} onChange={setValue(params)} />
        ) : (
          <HandlerAutocompleteField value={params.value || ""} showIcons={false} onChange={setValue(params)} />
        ),
    };
  };
  export const monthlyPeriodColumns = (periods: number[]): GridColDef[] =>
    periods.map((period) => ({
      field: period.toString(),
      headerName: formatPeriodLabel(period.toString()),
      width: 120,
      align: "center" as const,
      headerAlign: "center" as const,
      renderCell: (params: any) => (
        <span dir="ltr" style={{ fontWeight: params.row.id === "total" ? "bold" : "normal" }}>
          {params.value !== 0 ? formatCurrency(params.value) : ""}
        </span>
      ),
    }));
 export const policyNumberWithPathTooltipColumn = (headerName: string = "מספר פוליסה"): GridColDef => ({
  field: "policy_number",
  headerName,
  width: 130,
  renderCell: (params: any) => {
    const product = params.row.product;
    const policy = product?.policies_or_accounts?.[0];
    const mergedPaths = policy ? MimshakService.mergeDuplicateInvestmentPaths(policy.investment_paths) : [];

    const appointmentDateStr = params.row.agent_appointment_date;
    const reportedPeriodStr = params.row.reported_period;

    let showAgentChip = false;

    if (appointmentDateStr && reportedPeriodStr) {
      const appointmentDate = new Date(appointmentDateStr);
      const reportedPeriod = new Date(reportedPeriodStr);
      showAgentChip =
        appointmentDate.getFullYear() === reportedPeriod.getFullYear() &&
        appointmentDate.getMonth() === reportedPeriod.getMonth();
    }
    const showViewIcon = params.row.data_access_type === DataAccessTypeEnum.VIEW_ONLY;
    return (
      <Tooltip
        arrow
        title={
          <List dense>
            {mergedPaths.map((path, index) => (
              <ListItem key={index} disablePadding>
                <ListItemText
                  primary={`${path.path_name} (קוד: ${path.path_code})`}
                  secondary={`סכום צבירה: ${formatCurrency(path.accumulated_amount)}`}
                />
              </ListItem>
            ))}
          </List>
        }
      >
        <Box display="flex" alignItems="center" gap={1}>
          {params.value}
           {showViewIcon && (
            <VisibilityOutlinedIcon fontSize="small" color="action" />
          )}
          {params.row.new_policy && (
            <Chip label="חדש" size="small" color="success" />
          )}
          {showAgentChip && !params.row.new_policy &&(
            <Chip label="מינוי סוכן" size="small" color="info" />
          )}
        </Box>
      </Tooltip>
    );
  },
});   
export const policyNumberColumn = (): GridColDef => ({
  field: "policy_number",
  headerName: "מספר פוליסה",
  width: 180,
  sortable: true,
  filterable: true,
  renderCell: (params) => {
    const appointmentDateStr = params.row.agent_appointment_date;
    const reportedPeriodStr = params.row.reported_period;

    let showAgentChip = false;

    if (appointmentDateStr && reportedPeriodStr) {
      const appointmentDate = new Date(appointmentDateStr);
      const reportedPeriod = new Date(reportedPeriodStr);

      showAgentChip =
        appointmentDate.getFullYear() === reportedPeriod.getFullYear() &&
        appointmentDate.getMonth() === reportedPeriod.getMonth();
    }

    return (
      <Box display="flex" alignItems="center" gap={1}>
        {params.value}
        {params.row.new_policy && (
          <Chip label="חדש" size="small" color="success" />
        )}
        {showAgentChip && (
          <Chip label="מינוי סוכן" size="small" color="info" />
        )}
      </Box>
    );
  },
});
export const revClientColumn = (): GridColDef => ({
  field: "rev_client",
  headerName: "לקוח REV&U",
  width: 110,
  sortable: true,
  valueGetter: (_params: any, row: any) => row.rev_client === true ? "REV&U" : "",
  renderCell: (params: any) =>
    params.row.rev_client === true ? (
      <Box sx={{ color: "#6D4C41", fontWeight: 700, fontSize: "0.85rem" }}>
        REV&U
      </Box>
    ) : null,
});

  export const productStatusChipsColumn = (): GridColDef => ({
    field: "productStatusChips",
    headerName: "סטטוס",
    width: 180,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params: any) => {
      const product: Product | undefined = params.row.product;
  
      if (!product) return null;
  
      const policies = product.policies_or_accounts || [];
  
       return <PolicyStatuses product={product} showConversionFactors />;
    },
  });
  export const notesEditableColumn = (field: string = "notes", header: string = "הערות", required = false): AppGridColDef => ({
  field,
  headerName: header,
  width: 250,
  editable: true,
  required,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params: any) => (
    <Box sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{params.value}</Box>
  ),
  renderEditCell: (params: any) => (
    <TextField
      multiline
      fullWidth
      minRows={1}
      value={params.value || ""}
      onChange={(e) => {
        params.api.setEditCellValue({
          id: params.id,
          field: params.field,
          value: e.target.value,
        });
      }}
    />
  ),
});

export const editableCurrencyColumn = (
  field: string,
  headerName: string,
  width: number = 120,
  required: boolean = false
): AppGridColDef => ({
  field,
  headerName,
  width,
  editable: true,
  required,
  type: "number",
  renderCell: (params: any) =>
    typeof params.value === "number" && params.value !== 0 ? (
      <strong dir="ltr">{formatCurrency(params.value)}</strong>
    ) : (
      "-"
    ),
  renderEditCell: (params: any) => (
    <TextField
      fullWidth
      type="number"
      value={params.value || ""}
      onChange={(e) => {
        const numValue = e.target.value ? parseFloat(e.target.value) : null;
        params.api.setEditCellValue({
          id: params.id,
          field: params.field,
          value: numValue,
        });
      }}
      inputProps={{
        step: 0.01,
        min: 0,
      }}
    />
  ),
});

  export const transferOutToColumn = (): GridColDef<UserTaskMimshakData> => ({
    field: "transfer_out_to",
    headerName: "הועבר אל",
    width: 150,
    valueGetter: (params) => formatHandlerCode(params),
    renderCell: (params) => params.value,
  });
  export const transferOutToPathsColumn = (): GridColDef<UserTaskMimshakData> => ({
    field: "transfer_out_to_paths",
    headerName: "הועבר אל קופה",
    width: 300,
    sortable: false,
    filterable: true,
    valueGetter: (params,row) => {
      const data = row?.data as Mimshak;
      const actions: FundAction[] = row?.data?.products?.[0]?.policies_or_accounts?.[0]?.fund_actions ?? [];
  
      // סינון פעולות עם קופה מקבלת (שם+קוד)
      return actions
        .filter((a) => a.receiving_fund_name && a.receiving_fund_code)
        .map((a) => `${a.receiving_fund_name} (${a.receiving_fund_code})`)
        .join(", ");
    },
    renderCell: (params) => {
      const value = params.value as string;
  
      if (!value) return "";
  
      const items = value.split(", ");
  
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {items.map((item, index) => (
            <span key={index}>{item}</span>
          ))}
        </div>
      );
    },
  });

// Make sure SimulationChangeType, RuleType, formatRuleType, and colorRuleType are imported or defined above
export const ruleTypeColumn = (): GridColDef => 
  singleChipEnumColumn<RuleType>(
    "rule_type",
    "סוג תובנה",
    Object.values(RuleType),
    formatRuleType,
    colorRuleType,
    220
  );
  export const transferInFromColumn = (): GridColDef<UserTaskMimshakData> => ({
    field: "transfer_in_from",
    headerName: "הועבר מ־",
    width: 300,
    sortable: false,
    filterable: true,
    valueGetter: (params,row) => {
      const data = row?.data as Mimshak;
      const transfers: FundTransferDetails[] = row?.data?.products?.[0]?.policies_or_accounts?.[0]?.funds_transfer ?? [];
  
      return transfers
        .map((t) => `${t.transferring_fund_name} (${t.transferring_fund_id})`)
        .join(", ");
    },
    renderCell: (params) => {
      const value = params.value as string;
  
      if (!value) return "";
  
      const items = value.split(", ");
  
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {items.map((item, index) => (
            <span key={index}>{item}</span>
          ))}
        </div>
      );
    },
  });
  export const investmentPathsColumn = (): GridColDef => ({
    field: "investment_paths", // שם לוגי, לא חייב תואם לשדה במדויק
    headerName: "מסלולי השקעה",
    width: 300,
    sortable: false,
    filterable: false,
    valueGetter: (params,row) => {
      const data = row?.data as Mimshak;
      const paths: InvestmentPathDetail[] =
        data?.products?.[0]?.policies_or_accounts?.[0]?.investment_paths ?? [];

      return paths.map((p) => `${p.path_name} (${p.path_code})`).join(", ");
    },
    renderCell: (params) => {
      const value = params.value as string;

      if (!value) return "אין מסלולים";

      return (
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {value.split(", ").map((item, index) => (
            <span key={index}>{item}</span>
          ))}
        </div>
      );
    },
  });

/**
 * עמודה גנרית להצגת דמי ניהול בטבלה
 * מציגה ערך בודד או מספר ערכים עם tooltips מלאים
 * @param field - שם השדה (לדוגמה: "saving_fee" או "deposit_fee")
 * @param headerName - שם הכותרת
 * @param expenseType - סוג ההוצאה (FROM_SAVINGS או FROM_DEPOSITS)
 * @param width - רוחב העמודה
 */
export const managementFeeColumn = (
  field: string,
  headerName: string,
  expenseType: number,
  width: number = 120
): GridColDef => ({
  field,
  headerName,
  width,
  sortable: true,
  filterable: true,
  filterOperators: getGridNumericOperators(),
  // valueGetter לצורך מיון וחיפוש - מחזיר את הערך הראשון
  valueGetter: (params: number | number[], row: any) => {
    // אם יש גישה למידע המלא, ניקח את הערך הראשון מתוך management_fee_details
    const product = row?.data?.products?.[0];
    const policy = product?.policies_or_accounts?.[0];
    const management_fee_details = policy?.management_fee_details ?? [];

    const relevantFees = management_fee_details
      .filter((m: ManagementFeeDetails) => m.expense_type === expenseType && m.management_fee_rate !== 0)
      .map((m: ManagementFeeDetails) => m.management_fee_rate)
      .filter((v: any): v is number => typeof v === "number");

    if (relevantFees.length > 0) {
      return relevantFees[0];
    }

    // אחרת, נשתמש בערך שכבר חושב
    if (Array.isArray(params)) {
      return params.length > 0 ? params[0] : null;
    }
    return params ?? null;
  },
  // sortComparator - משווה ערכים למיון
  sortComparator: (v1: number | number[], v2: number | number[]) => {
    const val1 = Array.isArray(v1) ? (v1.length > 0 ? v1[0] : 0) : (v1 ?? 0);
    const val2 = Array.isArray(v2) ? (v2.length > 0 ? v2[0] : 0) : (v2 ?? 0);
    return val1 - val2;
  },
  renderCell: (params) => {
    const row = params.row;
    const product = row?.data?.products?.[0];
    const policy = product?.policies_or_accounts?.[0];
    const management_fee_details = policy?.management_fee_details ?? [];

    // אם יש גישה למידע המלא, נשתמש ב-ManagementFeeDisplay
    if (management_fee_details.length > 0) {
      const feesList = management_fee_details
        .filter(
          (m: ManagementFeeDetails) =>
            m.expense_type === expenseType && m.management_fee_rate !== 0
        )
        .reduce((unique: ManagementFeeDetails[], current: ManagementFeeDetails) => {
          const exists = unique.find(
            (u) => u.management_fee_rate === current.management_fee_rate
          );
          if (!exists) unique.push(current);
          return unique;
        }, [] as ManagementFeeDetails[]);

      return <ManagementFeeDisplay feesList={feesList} variant="body2" usePercentageFormat={true} />;
    }

    // אחרת, נשתמש בתצוגה פשוטה של הערכים
    const value = params.value as number | number[] | null;

    if (value === null || value === undefined) {
      return <span></span>;
    }

    if (typeof value === "number") {
      return (
        <span dir="ltr">
          {formatPercentage(value)}
        </span>
      );
    }

    if (Array.isArray(value) && value.length > 0) {
      if (value.length === 1) {
        return (
          <span dir="ltr">
            {formatPercentage(value[0])}
          </span>
        );
      }

      return (
        <Box display="flex" flexDirection="column" gap={0.3}>
          {value.map((fee, index) => (
            <span key={index} dir="ltr" style={{ fontSize: "0.875rem" }}>
              {formatPercentage(fee)}
            </span>
          ))}
        </Box>
      );
    }

    return <span></span>;
  },
});

/**
 * עמודה אוניברסלית לסוג מוצר
 * מציגה ProductType רגיל או ManualProductType עם צבע
 */
export const manualAdjustedTypeColumn = (
  field: string = "sub_type_label",
  headerName: string = "סוג מוצר",
  width: number = 150
): GridColDef => ({
  field,
  headerName,
  width,
  sortable: true,
  filterable: true,
  renderCell: (params) => {
    if (!params.value) return null;
    return (
      <Box
        sx={{
          color: "#232089",
          fontWeight: 600,
          fontSize: "0.85rem",
          px: 1,
          py: 0.5,
          borderRadius: 1,
          bgcolor: "#f0eeff",
          width: "100%",
          textAlign: "center",
        }}
      >
        {params.value}
      </Box>
    );
  },
});

export const productTypeUniversalColumn = (
  field: string = "product_type",
  headerName: string = "סוג מוצר",
  width: number = 180
): GridColDef => ({
  field,
  headerName,
  width,
  sortable: true,
  filterable: true,
  valueGetter: (params) => formatProductTypeUniversal(params),
  renderCell: (params) => {
    const productType = params.row[field];
    const color = colorProductTypeUniversal(productType);
    return (
      <Box
        sx={{
          backgroundColor: color,
          color: "white",
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          width: "100%",
          textAlign: "center",
        }}
      >
        {params.value}
      </Box>
    );
  },
});

/**
 * עמודה אוניברסלית לקוד יצרן
 * מציגה בנקים וחברות ביטוח (בעתיד) עם מלבן צבעוני בצד
 */
export const handlerCodeUniversalColumn = (
  field: string = "handler_code",
  headerName: string = "יצרן",
  backgroundColor?: string
): GridColDef => ({
  field,
  headerName,
  width: 150,
  valueGetter: (params) => formatHandlerCodeUniversal(params),
  renderCell: (params) => {
    const row = params.row || {};
    const code = row[field];

    if (!code) return null;

    const color = colorHandlerCodeUniversal(code);
    const label = formatHandlerCodeUniversal(code);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          backgroundColor: backgroundColor || "transparent",
          width: "100%",
          height: "100%",
          paddingRight: 4,
        }}
      >
        {color && (
          <div
            style={{
              width: 10,
              height: 30,
              borderRadius: "20%",
              backgroundColor: color,
              flexShrink: 0,
            }}
          />
        )}
        <span>{label}</span>
      </div>
    );
  },
});


